import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center p-20"
}
const _hoisted_2 = {
  key: 1,
  class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md mb-[25px]"
}
const _hoisted_3 = { class: "text-center p-10" }
const _hoisted_4 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_5 = {
  key: 2,
  class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md mb-[25px]"
}
const _hoisted_6 = { class: "text-center p-10" }
const _hoisted_7 = {
  key: 3,
  class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[25px] mb-[25px]"
}
const _hoisted_8 = { class: "trezo-card-header mb-[20px] flex items-center justify-between" }
const _hoisted_9 = { class: "trezo-card-title" }
const _hoisted_10 = { class: "mb-0" }
const _hoisted_11 = { class: "trezo-card-subtitle" }
const _hoisted_12 = { class: "trezo-card-content" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "flex items-center justify-between mb-[9px] mt-[20px]" }
const _hoisted_15 = { class: "text-lg mb-0 text-orange-500" }
const _hoisted_16 = {
  key: 0,
  class: "text-base font-medium mb-2 text-gray-800 dark:text-white truncate"
}
const _hoisted_17 = { class: "block relative pt-px ltr:pl-[22px] rtl:pr-[22px]" }
const _hoisted_18 = { class: "mt-[17px] py-[10px] border-y border-primary-50 dark:border-[#172036]" }
const _hoisted_19 = { class: "relative inline-block relative ltr:pl-[24px] rtl:pr-[24px] ltr:mr-[20px] rtl:ml-[20px] ltr:last:mr-0 rtl:last:ml-0" }
const _hoisted_20 = { class: "relative inline-block relative ltr:pl-[24px] rtl:pr-[24px] ltr:mr-[20px] rtl:ml-[20px] ltr:last:mr-0 rtl:last:ml-0" }
const _hoisted_21 = { class: "relative inline-block relative ltr:pl-[24px] rtl:pr-[24px] ltr:mr-[20px] rtl:ml-[20px] ltr:last:mr-0 rtl:last:ml-0" }
const _hoisted_22 = { class: "mt-[20px] flex items-center justify-between" }
const _hoisted_23 = { class: "flex items-center gap-[12px]" }
const _hoisted_24 = { class: "sm:text-[15px] md:text-md block font-semibold text-black dark:text-white" }
const _hoisted_25 = { class: "block" }
const _hoisted_26 = {
  key: 4,
  class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
}
const _hoisted_27 = { class: "trezo-card-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_DropdownBtn = _resolveComponent("DropdownBtn")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500 opacity-75" }, null, -1)
        ])))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-danger-500 text-3xl mb-3" }, [
                _createElementVNode("i", { class: "ri-error-warning-line" })
              ], -1)),
              _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-xl font-medium mb-2 text-danger-500" }, "Error Loading Properties", -1)),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.error), 1)
            ])
          ]))
        : (_ctx.properties.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-gray-400 text-3xl mb-3" }, [
                  _createElementVNode("i", { class: "ri-building-line" })
                ], -1)),
                _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-xl font-medium mb-2 text-gray-700 dark:text-gray-300" }, "No Properties Found", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-gray-500 dark:text-gray-400" }, "Your organization doesn't have any properties yet.", -1)),
                _createVNode(_component_RouterLink, {
                  to: "/real-estate/add-property",
                  class: "inline-block mt-4 font-medium px-5 py-2 rounded-md bg-primary-500 text-white hover:bg-primary-400 transition-colors"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" Add Your First Property ")
                  ])),
                  _: 1,
                  __: [4]
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedProperties, (property) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: property.id,
                  class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h5", _hoisted_10, _toDisplayString(property.city || 'No City'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_DropdownBtn)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_RouterLink, {
                      to: `/real-estate/property-details?id=${property.id}`,
                      class: "block rounded-[5px]"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: property.main_image_url || _ctx.placeholderImage,
                          class: "inline-block rounded-[5px] w-full h-48 object-cover",
                          alt: "property-image",
                          onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                        }, null, 40, _hoisted_13)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.formatPrice(property.price)), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["inline-block text-xs rounded-[4px] py-px px-[9px]", property.rent_or_sale === 'rent' ? 'bg-secondary-100 text-secondary-600' : 'bg-success-100 text-success-600'])
                      }, _toDisplayString(property.rent_or_sale === 'rent' ? 'Rent' : 'Sale'), 3)
                    ]),
                    (property.title)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_16, _toDisplayString(property.title), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_17, [
                      _cache[8] || (_cache[8] = _createElementVNode("i", { class: "material-symbols-outlined text-primary-500 absolute ltr:-left-[2px] rtl:-right-[2px] top-1/2 -translate-y-1/2 !text-[19px]" }, " location_on ", -1)),
                      _createTextVNode(" " + _toDisplayString(property.address || 'No Address'), 1)
                    ]),
                    _createElementVNode("ul", _hoisted_18, [
                      _createElementVNode("li", _hoisted_19, [
                        _cache[9] || (_cache[9] = _createElementVNode("i", { class: "material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-primary-500 !text-[18px]" }, " bed ", -1)),
                        _createTextVNode(" " + _toDisplayString(property.bedroom || '0') + "Bed ", 1)
                      ]),
                      _createElementVNode("li", _hoisted_20, [
                        _cache[10] || (_cache[10] = _createElementVNode("i", { class: "material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-primary-500 !text-[18px]" }, " bathtub ", -1)),
                        _createTextVNode(" " + _toDisplayString(property.bathroom || '0') + "Bath ", 1)
                      ]),
                      _createElementVNode("li", _hoisted_21, [
                        _cache[11] || (_cache[11] = _createElementVNode("i", { class: "material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-primary-500 !text-[18px]" }, " square_foot ", -1)),
                        _createTextVNode(" " + _toDisplayString(property.size || '0') + "sqft ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "w-[40px] h-[40px] rounded-full bg-gray-200 flex items-center justify-center" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined text-gray-500" }, "person")
                        ], -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(property.assignedUser?.display_name || 'Unassigned'), 1),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(property.status || 'Status Unknown'), 1)
                        ])
                      ]),
                      _createVNode(_component_RouterLink, {
                        to: `/real-estate/property-details?id=${property.id}`,
                        class: "inline-block font-medium sm:text-[15px] md:text-md text-primary-500 transition-all hover:text-primary-400 hover:underline"
                      }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode(" View More ")
                        ])),
                        _: 2,
                        __: [13]
                      }, 1032, ["to"])
                    ])
                  ])
                ]))
              }), 128))
            ])),
    (_ctx.properties.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_Pagination, {
              items: _ctx.itemsPerPage,
              total: _ctx.properties.length,
              class: "pt-[0] md:pt-[0]",
              onPageChange: _ctx.handlePageChange
            }, null, 8, ["items", "total", "onPageChange"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}